import QCXFinalFieldWrapper from '../../final-field/QCXFinalFieldWrapper';
import QCXTextField from '../../text-field/QCXTextField';
import type { AtributoCampoProps } from './types';

const formatDecimal = (value: unknown) => {
  if (value === undefined || value === null || value === '') return '';

  const number = Number(value);
  return Number.isNaN(number) ? value : number.toFixed(5);
};

const parseDecimal = (value: string) => {
  if (value === undefined || value === null || value === '') return value;

  const number = Number(value);
  return Number.isNaN(number) ? value : number;
};

export default function ValorRealV2({ atributo, basePath, disabled = false }: AtributoCampoProps) {
  const name = `${basePath}.${atributo.codigo}.valor`;
  const label = `${atributo.descricaoCodigo} (${atributo.codigo})`;

  return (
    <QCXFinalFieldWrapper
      name={name}
      label={label}
      component={QCXTextField}
      type="number"
      required
      validate={undefined}
      children={undefined}
      step="0.00001"
      disabled={disabled}
      format={formatDecimal}
      parse={parseDecimal}
      formatOnBlur
    />
  );
}
